export default (state) => val => {
    return state.list.filter(i => {
        return i.id === val;
    })[0];
}